import {
  GET_VEDIO_TOKEN,
  GET_VEDIO_TOKEN_SUCCESS,
  GET_VEDIO_TOKEN_FAILURE,
} from 'store/VedioCallToken/VedioCallTokenAction';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const getVedioCallReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_VEDIO_TOKEN:
      return { ...state, loading: true };
    case GET_VEDIO_TOKEN_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case GET_VEDIO_TOKEN_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default getVedioCallReducer;
